const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
        <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}{% include "wishlist-icon-black" %}</div>
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
        {% assign icon_name = "wishlist-icon-black" %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
        {% assign icon_name = "wishlist-icon" %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
      {% unless wishlist.read_only %}
        {% unless wishlist.item_count == 0 %}   
        <div class="wk-sharing">
          <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
          <ul class="wk-sharing__list">
            <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
            <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
            <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
            {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
          </ul>
          <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
        </div>
      {% endunless %}      
    {% endunless %}      
      {% if wishlist.item_count == 0 %}

          <div class="wk-note wk-note__list-empty">
            <p>{{ locale.wishlist_empty_note }}</p>
          </div>

      {% else %}

        {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
          <div class="wk-note wk-note__login">
            <p>{{ locale.login_or_signup_note }}</p>
          </div>
        {% endif %}

        <div>
          <div class="wk-grid">
            {% assign item_count = 0 %}
            {% assign products = wishlist.products | reverse %}
            {% for product in products %}
            {% assign item_count = item_count | plus: 1 %}
              {% unless limit and item_count > limit %}
                {% assign hide_default_title = false %}
                {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                  {% assign hide_default_title = true %}
                {% endif %}

                {% assign variant = product.selected_or_first_available_variant %}
                {% if variant.price < variant.compare_at_price %}
                  {% assign onsale = true %}
                {% else %}
                  {% assign onsale = false %}
                {% endif %}
                <div>
                  <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}" data-grid-id="{{ forloop.index }}">
                  <div class="wk-tags">
                    {% for tag in product.tags %}
                      {% if tag contains "badge" %}
                        {% assign t = tag | split: ':' %}
                        <span class="badge badge-{{ t[1] | downcase }}">{{ t[2] }}</span>
                      {% endif %}
                    {% endfor %}
                  </div>
                  {% assign quick_add = true %}
                  {% for tag in product.tags %}
                    {% if tag contains "bundle" %}
                      {% assign quick_add = false %}
                    {% endif %}
                  {% endfor %}
                  {% if quick_add == true %}
                    <div class="wk-quick-add" data-wk-identifier="{{ product.wishlist_item_id }}" data-shopify-id="{{ product.selected_or_first_available_variant.id }}">
                      <a href="#" class="wk-product-quick-link" data-wk-add-to-cart="{{ product.wishlist_item_id }}" data-shopify-id="{{ product.selected_or_first_available_variant.id }}" {% unless current_variant.available %}disabled{% endunless %}>
                        {% if current_variant.available %}
                          <span>Quick Add</span>
                        {% else %}
                          <span>{{ locale.sold_out }}</span>
                        {% endif %}
                        <div class="wk-quick-add__icon">
                          <svg class="icon icon--plus" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4191 6.43506H0.588867V7.77459H13.4191V6.43506Z" fill="currentColor"></path><path d="M7.8239 0.588379H6.5332V7.00001H7.8239V0.588379Z" fill="currentColor"></path><path d="M7.8239 9.02295H6.5332V13.4113H7.8239V9.02295Z" fill="currentColor"></path></svg>
                      </div>                      
                      </a>
                    </div>
                  {% endif %}
                    {% unless wishlist.read_only %}
                      {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                    {% else %}
                      {% include "wishlist-button-floating" product: product %}
                    {% endunless %}

                    <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})"></a>
                    <div class="wk-product-info__container">
                      <div class="wk-product-info">
                        <div class="wk-product-title__container">
                          <a class="wk-product-title" href="{{ product | variant_url }}">{{ product.title }}</a>
                        </div>
                        <div class="wk-product-price">
                          <span class="wk-product-price--current">{{ variant.price | money }}</span>
                          <span class="wk-product-price--compare">{{ variant.compare_at_price | money }}</span>
                        </div>
                      </div>

                      {% include "wishlist-product-form" %}
                    </div>
                  </div>
                </div>
              {% endunless %}
            {% endfor %}
          </div>
        </div>

        {% comment %}
        {% include "wishlist-button-bulk-add-to-cart" %}
        {% endcomment %}

        {% comment %}
        {% unless wishlist.read_only %}
          {% include "wishlist-button-clear" %}
        {% endunless %}
        {% endcomment %}
      {% endif %}
      </div>
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_or_first_available_variant %}
        <div class="wk-product-form__options">
          <input name="id" value="{{ current_variant.id }}" data-wk-identifier="{{ product.wishlist_item_id }}" class="secret" type="hidden">
          {% unless product.has_only_default_variant %}
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option">
                {% if option.values.length > 1 %}
                  <ul class="wk-product-form__option__radio-list">
                    {% for value in option.values limit: 4 %}
                      <li>
                        <input class="wk-product-form__option__radio-input" data-main-product="{{ product.id }}" data-wk-identifier="{{ product.wishlist_item_id }}" type="radio" id="{{ option.name }}-{{ value }}" name="options[{{ option.name | escape }}]" value="{{ value | escape }}" {% if option.selected_value == value %}checked{% endif %} {% if option.soldout_values contains value %}disabled{% endif %} />
                        <label class="wk-product-form__option__radio-label{% if option.selected_value == value %} active{% endif %}" data-shopify-id="{{ current_variant.id }}" for="{{ option.name }}-{{ value }}"><img src="${window.cdn.fileUrl}/{{ product.handle }}-{{ value | replace: " ", "-" | downcase }}_40x.png" /></label>
                      </li>
                    {% endfor %}
                    {% assign swatchCount = option.values.length %}
                    {% assign swatchRemainder = swatchCount | minus: 4 %}
                    {% if swatchRemainder > 0 %}
                      <li class="swatch-plus"><a href="{{ product | variant_url }}">+ {{ swatchRemainder }}</a></li>
                    {% endif %}
                  </ul>
                {% endif %}
              </div>
            {% endfor %}
          {% endunless %}
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
        <button class="visually-hidden" type="submit" disabled></button>
      </form>
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-icon",
    template: `
    <svg class="wishlist-icon-transparent" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.4204 6.98728C12.4204 6.98728 11.511 6.00212 10.4717 4.96283C9.43245 3.92354 7.59204 3.1549 5.97898 3.45802C4.09527 3.80445 2.67707 5.37421 2.15743 6.92232C1.811 7.93996 1.313 9.72624 2.89359 11.7507L12.1606 20.996C12.1606 20.996 19.7496 13.5153 20.843 11.978C22.835 9.17411 21.6982 6.71663 21.6982 6.71663C21.0703 5.10356 19.6305 3.57711 17.5302 3.23068C15.928 2.96003 15.0078 3.28481 14.0226 4.28079" stroke="currentColor" stroke-width="1.5" stroke-linejoin="bevel"/>
    </svg>
`,
  },
  {
    id: "wishlist-icon-black",
    template: `
    <svg class="wishlist-icon-black" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.6115 6.08864C21.7502 3.84299 19.8967 2.5 17.6508 2.5C14.7616 2.5 13.2461 4.25029 12.2431 5.42816C11.2619 4.2613 9.76819 2.55504 6.31206 2.55504C3.80445 2.55504 2.00551 4.51448 1.39497 6.34183C1.1006 7.21147 0.326508 9.51217 2.33259 12.0991L11.6652 21.5H12.8209C13.1371 21.1918 20.5291 13.8273 21.663 12.2202C23.9198 9.0168 22.6442 6.1657 22.6115 6.08864Z" fill="currentColor"/>
    </svg>`,
  },
  {
    id: "remove-icon",
    template: `
    <svg class="wishlist-icon-black" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.6115 6.08864C21.7502 3.84299 19.8967 2.5 17.6508 2.5C14.7616 2.5 13.2461 4.25029 12.2431 5.42816C11.2619 4.2613 9.76819 2.55504 6.31206 2.55504C3.80445 2.55504 2.00551 4.51448 1.39497 6.34183C1.1006 7.21147 0.326508 9.51217 2.33259 12.0991L11.6652 21.5H12.8209C13.1371 21.1918 20.5291 13.8273 21.663 12.2202C23.9198 9.0168 22.6442 6.1657 22.6115 6.08864Z" fill="currentColor"/>
    </svg>`,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
      <svg
      class="icon icon--facebook"
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.10374 10.8771V20H6.81553V10.8888H9.90936L10.3706 7.32564H6.81553V5.05718C6.81553 4.0265 7.10517 3.31877 8.59307 3.31877H10.4986V0.138405C10.1692 0.0952145 9.03944 0 7.72513 0C4.98245 0 3.10374 1.65497 3.10374 4.69693V7.3227H0V10.8771H3.10374Z"/>
    </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
      <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2868_76849)">
      <path d="M12.1182 0.589629C15.4682 0.589629 18.8173 0.605762 22.1673 0.581088C23.3752 0.571597 24.1813 1.55003 24.1758 2.649C24.1491 7.29064 24.1648 11.9332 24.1648 16.5758C24.1648 17.7564 23.3678 18.5801 22.2263 18.5801C15.5042 18.5801 8.78297 18.5801 2.06087 18.5801C0.957106 18.5801 0.185944 17.7887 0.185944 16.6555C0.185944 11.9513 0.199764 7.24793 0.17581 2.54366C0.170281 1.47032 0.976455 0.571597 2.0922 0.580139C5.4339 0.605762 8.77652 0.589629 12.1182 0.589629ZM12.1754 17.1462C15.3678 17.1462 18.5602 17.1462 21.7527 17.1462C22.347 17.1462 22.7634 16.7305 22.7634 16.1269C22.7652 12.2474 22.7643 8.36683 22.7652 4.48724C22.7652 4.28131 22.7173 4.10858 22.5211 4.00989C22.3212 3.91024 22.1608 3.99091 22.0088 4.11997C20.1634 5.68111 18.3179 7.24224 16.4725 8.80337C15.6193 9.52557 14.7698 10.2525 13.9102 10.9671C13.0055 11.7188 11.7239 11.825 10.7546 11.1588C10.0821 10.6967 9.47214 10.1367 8.84286 9.61004C8.02747 8.92769 7.22038 8.23396 6.4096 7.54593C5.60435 6.86263 4.7991 6.17934 3.99292 5.49795C3.43367 5.02628 2.87442 4.55367 2.30963 4.08866C2.07746 3.8979 1.79461 3.93112 1.67575 4.16837C1.61771 4.2851 1.59744 4.43315 1.59744 4.56696C1.59375 8.38581 1.59283 12.2037 1.5956 16.0225C1.5956 16.7561 1.98164 17.1471 2.68831 17.1471C5.85035 17.1462 9.01239 17.1462 12.1754 17.1462ZM12.1864 2.39371C11.6631 2.39371 11.1398 2.39371 10.6164 2.39371C8.24583 2.39371 5.87614 2.39371 3.50553 2.39371C3.36825 2.39371 3.20426 2.38517 3.17846 2.55599C3.16464 2.65089 3.22729 2.79799 3.30284 2.86158C4.5098 3.87418 5.72412 4.87824 6.93753 5.88325C8.36561 7.06572 9.79553 8.24535 11.2227 9.42877C11.7736 9.8862 12.5199 9.90234 13.0847 9.45725C13.2625 9.31679 13.4339 9.16969 13.609 9.02544C15.3079 7.61995 17.0059 6.21445 18.7049 4.80991C19.4908 4.15983 20.2758 3.50975 21.0626 2.86347C21.1925 2.75718 21.2598 2.62527 21.1455 2.49336C21.0856 2.42408 20.9474 2.3994 20.8442 2.3994C17.9586 2.39276 15.072 2.39371 12.1864 2.39371Z" fill="black"/>
      </g>
      <defs>
      <clipPath id="clip0_2868_76849">
      <rect width="24" height="18" fill="white" transform="translate(0.175781 0.580078)"/>
      </clipPath>
      </defs>
      </svg>
      
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
      <svg width="27" class="icon icon--link" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2868_76852)">
      <path d="M9.79122 10.6001C10.3382 10.3151 10.8854 10.0048 11.4545 9.74841C11.6539 9.65843 11.9177 9.66575 12.1359 9.69293C12.4037 9.72631 12.5955 9.83844 12.6687 10.1438C12.8801 11.0266 13.3782 11.7139 14.2929 12.0594C14.7757 12.2418 15.2784 12.2181 15.7924 12.0114C15.9507 11.9475 16.1061 11.8675 16.2545 11.7818C17.8125 10.8848 19.3665 9.98266 20.9259 9.08805C21.4879 8.76519 21.9015 8.33677 22.079 7.7497C22.2111 7.31363 22.1969 6.88095 22.0696 6.46906C21.8486 5.75466 21.4555 5.1599 20.7714 4.78016C20.074 4.39346 19.3364 4.43442 18.581 4.86404C17.5775 5.43454 16.5795 6.01315 15.5829 6.59581C15.45 6.67335 15.361 6.68502 15.244 6.60349C14.5846 6.14705 13.8203 5.8882 12.9832 5.78722C12.6557 5.74776 12.3147 5.75986 11.9607 5.74786C12.067 5.67356 12.159 5.59856 12.2612 5.53956C14.0062 4.52966 15.7353 3.48917 17.5042 2.52382C19.0438 1.68274 20.5923 1.60962 22.0718 2.27002C23.0701 2.71555 23.8016 3.42127 24.3262 4.32829C24.8981 5.31735 25.1359 6.39403 24.956 7.57971C24.7646 8.84419 24.1059 9.90844 23.0302 10.7686C22.738 11.0021 22.4143 11.2052 22.088 11.3944C20.4521 12.3413 18.8176 13.2923 17.1677 14.2133C16.2307 14.7364 15.2234 14.9306 14.2071 14.8253C12.4058 14.6392 11.1796 13.7224 10.382 12.2866C10.0979 11.7755 9.88718 11.2319 9.79122 10.6001Z" fill="black"/>
      <path d="M16.9335 10.4879C16.4921 10.7597 16.083 11.0332 15.6542 11.2695C15.2771 11.4774 14.8869 11.4807 14.5294 11.3127C14.4622 11.2809 14.42 11.1822 14.4 11.1046C14.2473 10.4925 13.9662 9.94983 13.4894 9.53222C12.6936 8.83613 11.7195 8.67324 10.6193 9.30923C9.01721 10.235 7.40845 11.1509 5.81338 12.0888C4.95353 12.5941 4.53167 13.3256 4.60662 14.2223C4.70808 15.436 5.30782 16.3345 6.51182 16.7569C7.11989 16.9698 7.7695 16.8306 8.37775 16.4794C9.36021 15.9122 10.3406 15.3429 11.322 14.7739C11.4014 14.728 11.4641 14.6805 11.5627 14.7427C12.4198 15.2802 13.3729 15.6076 14.5219 15.6063C14.4121 15.6745 14.3487 15.7161 14.2838 15.7535C12.7445 16.643 11.2031 17.5289 9.6663 18.421C8.82747 18.9086 7.94596 19.193 7.00106 19.237C5.95221 19.2858 5.03353 19.018 4.24389 18.4698C2.74438 17.4304 1.96851 15.9845 2.03968 14.1338C2.10299 12.496 2.93991 11.1489 4.46633 10.2069C6.12423 9.18323 7.82875 8.23235 9.52136 7.26404C10.7414 6.56615 12.0136 6.33975 13.3061 6.63C14.2062 6.83231 14.9501 7.27401 15.5638 7.89052C16.2951 8.62469 16.7291 9.51835 16.9335 10.4879Z" fill="black"/>
      </g>
      <defs>
      <clipPath id="clip0_2868_76852">
      <rect width="25" height="10" fill="white" transform="translate(0.175781 12.5) rotate(-30)"/>
      </clipPath>
      </defs>
      </svg>
      
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
